// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vJ-z","twoColumnImage":"wJ-z"};